import angular from 'angular'

import component from './purchase-record.component'

let module = angular.module('purchaseRecord', [])

.component('purchaseRecord', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/purchase-record/index.js